/* eslint-disable import/prefer-default-export */
export const DISTANCE_DROPDOWN_ID = "distance-dropdown";
